 
import React, { useEffect } from 'react';
import styleClasses from './selectCard.module.scss';
import { addCode, addExtendableLimit, give_me_my_classes } from '../../../../helpers/helperMethods';
import { selectedBtnStyle } from '../cardStyle';
import * as Constant from '../../../../constants';
import { ISelectCard } from '../../../../models/card';
import Labels from '../CardLabels/Labels';
import NotAvailable from '../../../Buttons/NotAvailable';
import { useLocation } from 'react-router';
import useCheckMobileScreen from '../../../../hooks/useCheckMobileScreen';
import { useIsDesignV2 } from '../../../../hooks/useIsDesignV2';

const SelectCard: React.FC<ISelectCard> = (props) => {
  const {
    id,
    brink_id,
    image,
    title,
    price,
    calories,
    selected,
    handleClick,
    default_selected,
    parentClassName,
    buttonText,
    is_active,
    disable,
    priceAlternateLabel,
    modifierAdditionalPrice,
    componentUsedIn,
    extendableLimit = 0,
    extendableLimitValue,
    groupMin,
    isItEdit=false,
    nestedParentId,
    showRedBorderAnimation,
    upsellCardPadding,
    isCreateYourOwnItem,
    shouldAutoSelect=false,
    modifier_count,
    relatedModifierGroupId,
  } = props;

  const handleSelectButtonClick = (type:string, selected:boolean) => {
    if((extendableLimitValue === 1 && groupMin === 1 && selected && type !== Constant.BY_DEFAULT)){
      return;
    }else{
      let payload:any = {
        modifier_id: id,
        modifier_name: title,
        display_price: price,
        modifier_calories: calories,
        modifier_group_min:groupMin,
        brink_id,
        type: type,
        is_selected: default_selected,
        image,
        modifier_count,
        related_modifier_group: relatedModifierGroupId,
      }
      if(type === Constant.BY_DEFAULT){
        payload.core = true
      }
      payload = addCode(selected ? Constant.DECREASE : Constant.INCREASE,payload)
      payload = addExtendableLimit(payload,type,extendableLimitValue)
      if( nestedParentId ) payload.nested_parent_id = nestedParentId
      handleClick(payload);
    }
  };

  const isItSubstitute = () => {
    return extendableLimitValue === 1 && groupMin === 1
  }

  const assignBorderClass = () => {
    if(default_selected && selected && isItSubstitute()){
      return give_me_my_classes(
        ['add_on_item_wrap', 'selected'],
        styleClasses
      );
    }else if (default_selected && !selected && !isItSubstitute()) {
      return give_me_my_classes(
        ['add_on_item_wrap', 'exclude'],
        styleClasses
      );
    } else if (!default_selected && selected) {
      return give_me_my_classes(
        ['add_on_item_wrap', 'selected'],
        styleClasses
      );
    } else {
      return '';
    }
  };
  
  const selectCardClickDisable = () => {
    return (disable) || (extendableLimit && !selected)
  }

  const selectCard = () => {
    return !selectCardClickDisable() && is_active && handleSelectButtonClick(Constant.SELECTED, selected);
  }

  useEffect(() => {
    shouldAutoSelect && selectCard();
  }, [shouldAutoSelect]);
  const location = useLocation();
  const isThisMobile = useCheckMobileScreen();
  const isDesignV2 = useIsDesignV2();
  return (
    <div
      className={
        parentClassName ||
        `${
          styleClasses.item_wrap
        } ${assignBorderClass()} add_on_item_wrap shadow-box d-flex flex-column cursor-pointer ${showRedBorderAnimation && !selected ? 'border-size-select' : ''}`
      }
      onClick={selectCard}
      style={{ ...(!is_active && { opacity: 0.7 }) }}
      data-testid="fullSelectCard"
    >
      <div
        className={`${styleClasses.items_image} ${isDesignV2 && styleClasses.item_image_design_v2} ${selectCardClickDisable() && 'opacity-50'} ${!isThisMobile && "flex-fill"}  mb-0 d-flex align-items-center justify-content-center items__image_wrap`}
      >
        <img src={image} className="img-fluid" alt={title}/>
      </div>
      <div className={`${styleClasses.items_inn_content} items__inn_content ${upsellCardPadding}`}>
        <h3 className={`${styleClasses.item_title} font-rale mb-3`}>{title} 
        <span className={`${styleClasses.tooltiptext} `}>{title}</span>
        </h3>
      {is_active ? (
        <button
          type="button"
          className={`${styleClasses.selected_kids_combo} ${selected && !disable ? styleClasses.item_btn_selected: null} btn item-select-btn mb-md-3 mb-0 aaas w-md-50`}
          data-testid="select-card-button"
          disabled={selectCardClickDisable()}
        >
          {selected ? buttonText || 'Selected' : buttonText || 'Select'}
        </button>
      ) : (
        <NotAvailable selectedBtnStyle={selectedBtnStyle} />
      )}
      <Labels
        price={price}
        priceAlternateLabel={priceAlternateLabel}
        additionalPrice={modifierAdditionalPrice}
        calories={calories}
        isCreateYourOwnItem={isCreateYourOwnItem}
        isItSubstitute={extendableLimitValue === 1 && groupMin === 1}
      />
      </div>
    </div>
  );
};

export default SelectCard;
